export const common = {
  // Navigation
  home: 'Início',
  fleet: 'Frota',
  services: 'Serviços',
  about: 'Sobre Nós',
  contact: 'Contactos',
  contacts: 'Contactos',
  
  // Buttons
  bookNow: 'Reservar Agora',
  viewFleet: 'Ver Frota',
  requestQuote: 'Solicitar Orçamento',
  getQuote: 'Obter Orçamento',
  submit: 'Enviar',
  
  // Hero Section
  heroTitle: 'Reserve hoje o seu transfer sem stress e poupe até 40%',
  heroSubtitle: 'Ligamos você ao Aeroporto de Faro com conforto e segurança',
  heroMainTitle: 'Transfers Aeroporto Faro Algarve',
  heroMainSubtitle: 'Licenciados e Segurados 24/7',
  heroServiceTitle: 'Transfers Totalmente Licenciados e Segurados • Disponível 24/7',
  heroServiceSubtitle: 'Serviço premium do Aeroporto de Faro para todo o Algarve com preços fixos garantidos',
  heroBenefit1: 'Licenciados',
  heroBenefit2: 'Segurados',
  heroBenefit3: 'Preços Fixos',
  heroCtaBook: 'Reservar Agora',
  heroCtaPricing: 'Ver Preços',
  heroTrust1: '4.9★ Avaliação',
  heroTrust2: '5000+ Clientes',
  heroTrust3: 'Disponível 24/7',
  
  // Services Section - Main
  servicesTitle: 'Nossos Serviços',
  servicesSubtitle: 'Oferecemos uma gama completa de serviços de transporte para tornar a sua estadia no Algarve inesquecível',
  servicesMainTitle: 'Serviços de Transfer Low Cost',
  servicesMainSubtitle: 'Transfers confiáveis do Aeroporto de Faro para todo o Algarve. Serviço licenciado, segurado e disponível 24/7.',
  
  // Services - Individual Cards
  service1Title: 'Transfers Aeroporto',
  service1Desc: 'Serviço de transfer do/para o Aeroporto de Faro com pontualidade garantida e monitorização de voos em tempo real.',
  service1Keywords: 'Transfer Aeroporto Faro, Táxi Aeroporto, Transporte Aeroporto',
  service1Feature1: 'Monitorização de voos',
  service1Feature2: 'Motorista à espera',
  service1Feature3: 'Sem custos de espera',
  
  service2Title: 'Transfers Privados',
  service2Desc: 'Transporte privado e exclusivo para qualquer destino no Algarve. Conforto, privacidade e flexibilidade total.',
  service2Keywords: 'Transfer Privado Algarve, Transporte Privado, Viagem Exclusiva',
  service2Feature1: 'Conhecimento local',
  service2Feature2: 'Rotas otimizadas',
  service2Feature3: 'Flexibilidade de horários',
  
  service3Title: 'Disponível 24/7',
  service3Desc: 'Serviço disponível 24 horas por dia, 7 dias por semana. Estamos sempre prontos para o servir, a qualquer hora.',
  service3Keywords: 'Transfer 24 Horas, Serviço 24/7, Disponível Sempre',
  service3Feature1: 'Emergências',
  service3Feature2: 'Voos tardios',
  service3Feature3: 'Flexibilidade total',
  
  service4Title: 'Licenciados e Segurados',
  service4Desc: 'Todos os nossos veículos e motoristas são totalmente licenciados e segurados para sua segurança e tranquilidade.',
  service4Keywords: 'Táxi Licenciado Faro, Transfer Segurado, Serviço Certificado',
  service4Feature1: 'Motoristas certificados',
  service4Feature2: 'Veículos inspecionados',
  service4Feature3: 'Seguro abrangente',
  
  service5Title: 'Preços Low Cost',
  service5Desc: 'Oferecemos os melhores preços do mercado sem comprometer a qualidade do serviço. Descontos especiais para ida e volta.',
  service5Keywords: 'Transfer Barato Algarve, Preço Low Cost, Desconto Transfer',
  
  service6Title: 'Motoristas Profissionais',
  service6Desc: 'Motoristas experientes, licenciados e com conhecimento profundo do Algarve. Atendimento de excelência garantido.',
  service6Keywords: 'Motorista Profissional, Condutor Experiente, Serviço Premium',
  
  // Why Choose FARWAYS
  whyChooseFarways: 'Porquê Escolher a FARWAYS?',
  whyReason1Title: 'Transfers Low Cost Certificados',
  whyReason1Desc: 'Todos os nossos táxis são licenciados e cumprem todas as regulamentações de transporte de passageiros em Portugal.',
  whyReason2Title: 'Seguro Completo',
  whyReason2Desc: 'Cobertura de seguro total para passageiros e bagagem em todos os transfers do Aeroporto de Faro.',
  whyReason3Title: 'Preços Transparentes',
  whyReason3Desc: 'Sem custos ocultos. O preço que vê é o preço que paga. Descontos especiais para viagens de ida e volta.',
  whyReason4Title: 'Reserva Online Fácil',
  whyReason4Desc: 'Reserve em 2 minutos. Confirmação imediata por email. Alterações gratuitas até 24h antes.',
  
  // Fleet
  fleetTitle: 'Nossa Frota',
  fleetSubtitle: 'Veículos modernos e confortáveis para todas as suas necessidades de transporte no Algarve',
  ourFleet: 'Nossa Frota',
  fleetDescription: 'Veículos modernos e confortáveis para todas as suas necessidades de transporte',
  fleetPassengers: 'Passageiros',
  luggage: 'Bagagem',
  
  fleetEconomico: 'Económico',
  fleetEconomicoDesc: 'Ideal para viagens individuais ou casais',
  fleetConforto: 'Conforto',
  fleetConfortoDesc: 'Perfeito para famílias pequenas',
  fleetSUV: 'SUV',
  fleetSUVDesc: 'Máximo conforto e estilo',
  fleetMPV: 'MPV',
  fleetMPVDesc: 'Espaço extra para bagagem',
  fleetMinivan: 'Minivan',
  fleetMinivanDesc: 'Ideal para grupos e famílias grandes',
  fleetMinibus: 'Minibus',
  fleetMinibusDesc: 'Para grupos grandes e eventos',
  
  fleetFeature1: 'Ar Condicionado',
  fleetFeature2: 'Wi-Fi Gratuito',
  fleetFeature3: 'Motorista Profissional',
  fleetFeature4: 'Assentos em Couro',
  fleetFeature5: 'Água Gratuita',
  fleetFeature6: 'Assentos Premium',
  fleetFeature7: 'Sistema de Som',
  fleetFeature8: 'Espaço Extra',
  fleetFeature9: 'Porta USB',
  fleetFeature10: 'Assentos Individuais',
  fleetFeature11: 'Entretenimento',
  fleetFeature12: 'Espaço Premium',
  
  fleetExample1: 'Faro Aeroporto » Vilamoura',
  fleetExample2: 'Faro Aeroporto » Albufeira',
  fleetExample3: 'Faro Aeroporto » Carvoeiro',
  fleetExample4: 'Faro Aeroporto » Tavira',
  fleetExample5: 'Faro Aeroporto » Portimão',
  fleetExample6: 'Faro Aeroporto » Lagos',
  
  // About
  aboutTitle: 'Sobre a FARWAYS VIAGENS',
  aboutSubtitle: 'Excelência em transfers no Algarve há mais de 10 anos',
  aboutDesc1: 'Somos uma empresa especializada em transfers e transporte turístico no Algarve, com mais de 15 anos de experiência no setor. A nossa missão é proporcionar viagens seguras, confortáveis e pontuais a todos os nossos clientes.',
  aboutDesc2: 'Com uma frota moderna e diversificada, servimos o Aeroporto de Faro e toda a região do Algarve, oferecendo soluções de transporte personalizadas para turistas, empresas e eventos especiais.',
  
  aboutFeature1: 'Motoristas licenciados e experientes',
  aboutFeature2: 'Frota moderna e bem mantida',
  aboutFeature3: 'Preços competitivos e transparentes',
  aboutFeature4: 'Atendimento personalizado 24/7',
  
  aboutStat1: '5000+',
  aboutStat1Label: 'Clientes Satisfeitos',
  aboutStat2: '15+',
  aboutStat2Label: 'Anos de Experiência',
  aboutStat3: '50+',
  aboutStat3Label: 'Veículos na Frota',
  aboutStat4: '24/7',
  aboutStat4Label: 'Disponibilidade',
  
  yearsLabel: 'Anos de Experiência',
  
  // Contact
  contactTitle: 'Contactos',
  contactSubtitle: 'Entre em contacto connosco para mais informações ou reservas',
  phone: 'Telefone',
  email: 'Email',
  address: 'Morada',
  schedule: 'Horário',
  scheduleText: '24 horas por dia\n7 dias por semana',
  
  formTitle: 'Envie-nos uma Mensagem',
  nameLabel: 'Nome',
  namePlaceholder: 'O seu nome',
  emailPlaceholder: 'o.seu.email@exemplo.com',
  phoneLabel: 'Telefone',
  phonePlaceholder: '+351 912 345 678',
  subjectLabel: 'Assunto',
  subjectPlaceholder: 'Assunto da mensagem',
  messageLabel: 'Mensagem',
  messagePlaceholder: 'A sua mensagem...',
  submitButton: 'Enviar Mensagem',
  successMessage: 'Mensagem enviada com sucesso!',
  errorMessage: 'Erro ao enviar mensagem. Tente novamente.',
  
  // Footer
  footerDescription: 'Serviços de transfer premium no Algarve. Ligamos você aos melhores destinos com conforto e segurança.',
  quickLinks: 'Links Rápidos',
  followUs: 'Siga-nos',
  allRightsReserved: 'Todos os direitos reservados.',
  privacyPolicy: 'Política de Privacidade',
  termsOfService: 'Termos de Serviço',
  
  // Booking Engine
  bookingTitle: 'Planeie a Sua Viagem Connosco',
  bookingSubtitle: 'Simples, rápido e sem complicações',
  from: 'De',
  to: 'Para',
  date: 'Data',
  time: 'Hora',
  passengers: 'Passageiros',
  passengerSingular: 'Passageiro',
  passengerPlural: 'Passageiros',
  returnTrip: 'Viagem de Regresso',
  searchTransfers: 'Confirmar Reserva',
  processing: 'A processar...',
  bookingConfirmed: 'Reserva confirmada!',
  reservationNumber: 'Número da reserva',
  pdfSentTo: 'PDF enviado para',
  bookingError: 'Erro ao criar reserva. Por favor, tente novamente.',
  fullName: 'Nome completo',
  destination: 'Destino',
  
  // Child Seats
  childSeats: 'Assentos para Crianças',
  childSeat0to1: '0-1 anos (€7)',
  childSeat1to3: '1-3 anos (€6)',
  childSeat5to12: '5-12 anos (€4)',
  childSeat0to1Short: '0-1 anos',
  childSeat1to3Short: '1-3 anos',
  childSeat5to12Short: '5-12 anos',
  seat: 'assento',
  seats: 'assentos',
  childSeatsIncluded: 'Assentos para crianças incluídos',
  
  // Observations
  observations: 'Observações',
  observationsPlaceholder: 'Ex: 2 tacos de golfe, bagagem extra, etc.',
  
  // Privacy Policy
  privacyPolicyTitle: 'Política de Privacidade',
  privacyLastUpdated: 'Última atualização',
  privacyIntro: 'A FARWAYS VIAGENS respeita a sua privacidade e está comprometida em proteger os seus dados pessoais. Esta política de privacidade explica como recolhemos, usamos e protegemos as suas informações pessoais em conformidade com o Regulamento Geral de Proteção de Dados (RGPD).',
  acceptPrivacyPart1: 'Li e aceito a',
  acceptPrivacyPart2: '',
  mustAcceptPrivacy: 'Deve aceitar a política de privacidade para continuar.',
  
  // Terms of Service
  termsTitle: 'Termos e Condições de Serviço',
  termsLastUpdated: 'Última atualização: Janeiro 2025',
  
  termsSection1Title: '1. Aceitação dos Termos',
  termsSection1Text1: 'Ao utilizar o website da FARWAYS e os nossos serviços de transfer, você concorda com estes Termos e Condições de Serviço. Se não concordar com qualquer parte destes termos, não deverá utilizar os nossos serviços.',
  termsSection1Text2: 'Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em vigor imediatamente após a sua publicação no website.',
  
  termsSection2Title: '2. Serviços Oferecidos',
  termsSection2Text1: 'A FARWAYS oferece serviços de transfer premium no Algarve, incluindo:',
  termsSection2Item1: 'Transfers de e para aeroportos',
  termsSection2Item2: 'Transfers entre cidades e hotéis',
  termsSection2Item3: 'Serviços de transporte executivo',
  termsSection2Item4: 'Tours personalizados',
  termsSection2Item5: 'Reservas através do sistema online com confirmação automática',
  
  termsSection3Title: '3. Reservas e Confirmações',
  termsSection3Text1: 'Ao efetuar uma reserva através do nosso sistema online:',
  termsSection3Item1: 'Receberá um número de reserva único e um PDF de confirmação por email',
  termsSection3Item2: 'A reserva é considerada confirmada após o envio do email de confirmação',
  termsSection3Item3: 'Deve apresentar o número de reserva ao motorista no momento do serviço',
  termsSection3Item4: 'É responsável por fornecer informações corretas e completas (nome, email, telefone, locais e horários)',
  
  termsSection4Title: '4. Cancelamentos e Alterações',
  termsSection4Text1: 'Política de cancelamento e alterações:',
  termsSection4Item1: 'Cancelamentos com mais de 24 horas de antecedência: reembolso total',
  termsSection4Item2: 'Cancelamentos entre 12-24 horas: reembolso de 50%',
  termsSection4Item3: 'Cancelamentos com menos de 12 horas: sem reembolso',
  termsSection4Item4: 'Alterações de data/hora devem ser solicitadas com pelo menos 24 horas de antecedência',
  
  termsSection5Title: '5. Pagamento',
  termsSection5Text1: 'O pagamento pode ser efetuado através de cartão de crédito/débito ou em dinheiro diretamente ao motorista. Os preços apresentados incluem todos os impostos aplicáveis.',
  termsSection5Text2: 'Reservamo-nos o direito de ajustar os preços sem aviso prévio, mas os preços confirmados no momento da reserva serão honrados.',
  
  termsSection6Title: '6. Responsabilidades do Cliente',
  termsSection6Text1: 'O cliente compromete-se a:',
  termsSection6Item1: 'Estar presente no local de recolha à hora agendada (recomendamos 10 minutos antes)',
  termsSection6Item2: 'Informar sobre bagagem extra ou necessidades especiais no momento da reserva',
  termsSection6Item3: 'Comportar-se de forma respeitosa com o motorista e manter o veículo limpo',
  
  termsSection7Title: '7. Limitação de Responsabilidade',
  termsSection7Text1: 'A FARWAYS não se responsabiliza por atrasos causados por condições de tráfego, condições meteorológicas adversas, ou outros fatores fora do nosso controlo.',
  termsSection7Text2: 'Não nos responsabilizamos por objetos pessoais deixados nos veículos, embora façamos todos os esforços para devolver itens encontrados.',
  
  termsSection8Title: '8. Proteção de Dados',
  termsSection8Text1: 'Os seus dados pessoais são tratados de acordo com a nossa Política de Privacidade e o Regulamento Geral de Proteção de Dados (RGPD).',
  termsSection8Text2: 'As informações fornecidas durante a reserva são armazenadas de forma segura no nosso sistema e utilizadas exclusivamente para a prestação do serviço.',
  
  termsSection9Title: '9. Lei Aplicável',
  termsSection9Text1: 'Estes termos são regidos pela lei portuguesa. Qualquer disputa será resolvida nos tribunais competentes de Portugal.',
  
  termsSection10Title: '10. Contacto',
  termsSection10Text1: 'Para questões sobre estes Termos e Condições, contacte-nos:',
  
  contactInfo: 'Informações de Contacto',
  backToHome: 'Voltar ao Início',
  
  // Legal Links
  complaintsBook: 'Livro de Reclamações',
  arbitrationCenter: 'Centro de Arbitragem',
  cookiePolicy: 'Política de Cookies',
  name: 'Nome',
  
  // Pricing Page
  pricingTitle: 'Tarifário de Transfers',
  pricingSubtitle: 'Preços transparentes e fixos para todas as rotas do Algarve',
  pricingDescription: 'Consulte os nossos preços competitivos para transfers do Aeroporto de Faro para os principais destinos do Algarve e Espanha.',
  route: 'Rota',
  economico: 'Económico',
  conforto: 'Conforto',
  suv: 'SUV',
  mpv: 'MPV',
  minivan: 'Minivan',
  minibus: 'Minibus',
  luxo: 'Luxo',
  bookThisRoute: 'Reservar Esta Rota',
  pricesIncludeVAT: 'Todos os preços incluem IVA',
  noHiddenFees: 'Sem custos escondidos',
  fixedPrices: 'Preços fixos garantidos',
  allVehiclesInclude: 'Todos os veículos incluem',
  professionalDriver: 'Motorista profissional',
  freeWifi: 'Wi-Fi gratuito',
  airConditioning: 'Ar condicionado',
  freeWater: 'Água gratuita',
  flightMonitoring: 'Monitorização de voos',
  meetAndGreet: 'Serviço meet & greet',
  pricing: 'Tarifário',
  vehicleType: 'Tipo de Veículo',
  totalValue: 'Valor Total',
  discountApplied: 'Desconto de 10% aplicado (ida e volta)',
  action: 'Ação',
  importantInfo: 'Informações Importantes',
  oneWayPrices: 'Preços válidos para viagens de ida',
  roundTripDiscount: 'Viagens de ida e volta: desconto de 10%',
  pricesIncludeTax: 'Todos os preços incluem IVA à taxa legal',
  noWaitingCosts: 'Sem custos de espera no aeroporto',
  searchRoute: 'Pesquisar rota por destino...',
  noRoutesFound: 'Nenhuma rota encontrada',
  routeFound: 'rota encontrada',
  routesFound: 'rotas encontradas',
  tryDifferentSearch: 'Tente pesquisar por outro destino ou limpe a pesquisa para ver todas as rotas.',
  clearSearch: 'Limpar Pesquisa',
  
  // Winter Discount
  winterDiscount: '❄️ Desconto de Inverno - 30% OFF',
  winterDiscountDescription: 'Válido de Novembro a Março + 10% adicional em viagens de ida e volta',
  winterDiscountActive: 'Desconto de inverno de 30% já aplicado nos preços apresentados',
  winterDiscountApplied: 'Desconto de inverno de 30% aplicado',
  
  // Booking Engine Additional
  routeNotInTable: 'Rota não encontrada na tabela de preços',
  contactForQuote: 'Entre em contacto connosco para um orçamento personalizado para esta rota.',
  
  // 404 Page
  notFoundTitle: 'Página Não Encontrada',
  notFoundSubtitle: 'Parece que esta rota não existe no nosso mapa',
  notFoundDescription: 'A página que procura pode ter sido movida ou não existe. Mas não se preocupe, podemos levá-lo de volta ao destino certo!',
  goHome: 'Voltar ao Início',
  viewPricing: 'Ver Tarifário',
  contactUs: 'Contacte-nos',
  error404: 'Erro 404',
  
  // Contact Page Additional
  contactInformation: 'Informações de Contacto',
  howToGetHere: 'Como Chegar',
  findUsEasily: 'Encontre-nos facilmente no centro de Faro',
  sendUsMessage: 'Envie-nos uma Mensagem',
  fillFormBelow: 'Preencha o formulário abaixo e entraremos em contacto consigo brevemente.',
  maxCharacters: 'Máximo 500 caracteres',
  onlineComplaintsBook: 'Livro de Reclamações Online',
  algarveArbitrationCenter: 'Centro de Arbitragem de Consumo do Algarve',
  
  // Testimonials
  testimonialsTitle: 'O Que Dizem os Nossos Clientes',
  testimonialsSubtitle: 'Mais de 5000 clientes satisfeitos confiam nos nossos serviços de transfer',
  testimonial1: 'Serviço impecável! O motorista estava à minha espera no aeroporto com uma placa com o meu nome. O carro era luxuoso e muito confortável. Recomendo vivamente para quem procura qualidade e pontualidade.',
  testimonial2: 'Já utilizei os serviços da FARWAYS várias vezes para viagens de negócios. Sempre pontuais, profissionais e com veículos em excelente estado. É a minha primeira escolha para transfers no Algarve.',
  testimonial3: 'Fizemos uma viagem em família e reservámos uma minivan. Espaço mais do que suficiente para todos nós e as malas. O motorista foi muito simpático e deu-nos ótimas dicas sobre a região. Experiência fantástica!',
  testimonial4: 'Excelente relação qualidade-preço. O serviço superou as minhas expectativas. Motorista muito educado e conhecedor da região. Voltarei a utilizar com certeza.',
  testimonial5: 'Serviço de primeira classe! Reservei um transfer do aeroporto para o hotel e foi tudo perfeito. O veículo era novo e muito limpo. Senti-me muito segura durante toda a viagem.',
  testimonial6: 'Utilizo regularmente para viagens de negócios. A pontualidade é impressionante e os motoristas são sempre muito profissionais. O melhor serviço de transfers que já experimentei em Portugal.',
  testimonialDate1: 'Março 2024',
  testimonialDate2: 'Fevereiro 2024',
  testimonialDate3: 'Janeiro 2024',
  testimonialDate4: 'Dezembro 2023',
  testimonialDate5: 'Novembro 2023',
  testimonialDate6: 'Outubro 2023',
  averageRating: 'Avaliação Média',
  happyClients: 'Clientes Satisfeitos',
  verified: 'Verificado',
  awards: 'Prémios',
  
  // FAQ Page
  faqTitle: 'Perguntas Frequentes',
  faqSubtitle: 'Encontre respostas rápidas para as dúvidas mais comuns sobre os nossos serviços de transfer no Algarve',
  
  // FAQ Categories
  faqCategoryAll: 'Todas',
  faqCategoryReservas: 'Reservas e Alterações',
  faqCategoryAeroporto: 'Aeroporto e Encontro',
  faqCategoryBagagem: 'Bagagem e Extras',
  faqCategoryServico: 'Tipos de Serviço',
  faqCategoryPagamento: 'Pagamento e Preços',
  faqCategorySeguranca: 'Segurança e Confiança',
  
  // FAQ Questions and Answers - Reservas
  faqQuestion1: 'Posso fazer alterações na minha reserva?',
  faqAnswer1: 'Sim, pode alterar a sua reserva até 24 horas antes do horário de embarque agendado. Para alterar, aceda à secção "Minha Reserva" no nosso site usando os dados do seu email de confirmação. Caso não consiga aceder online, contacte-nos através do formulário de contacto ou ligue para +351 937 545 000.',
  
  faqQuestion2: 'Como posso cancelar a minha reserva?',
  faqAnswer2: 'Pode cancelar através da secção "Minha Reserva" do nosso site, utilizando os dados do email de confirmação. Política de cancelamento:\n\n• Mais de 24h de antecedência: reembolso total\n• Entre 12-24h: reembolso de 50%\n• Menos de 12h: sem reembolso\n\nCaso não consiga aceder online, contacte-nos diretamente.',
  
  faqQuestion3: 'E se o meu voo atrasar ou for cancelado?',
  faqAnswer3: 'Não se preocupe! Monitorizamos todos os voos automaticamente. Se o seu voo atrasar, o seu motorista será informado e ajustará o horário de recolha. Não há custos adicionais por atrasos de voo. A atualização está sujeita à disponibilidade do motorista.',
  
  faqQuestion4: 'Os meus dados de voo mudaram, preciso informar?',
  faqAnswer4: 'Sim, por favor envie a nova programação de voo o mais breve possível através da secção "Minha Reserva" ou contacte-nos diretamente. Se o embarque for em menos de 24 horas, ligue urgentemente para +351 937 545 000 para garantir que o motorista esteja informado.',
  
  // FAQ Questions and Answers - Aeroporto
  faqQuestion5: 'Qual é o ponto de encontro no aeroporto?',
  faqAnswer5: 'O motorista estará à sua espera no saguão de desembarque do Aeroporto de Faro (zona de chegadas), segurando uma placa com o seu nome. O local exato será confirmado no email de confirmação da reserva. Caso não encontre o motorista, ligue para o número de emergência fornecido no email.',
  
  faqQuestion6: 'Quanto tempo o motorista espera no aeroporto?',
  faqAnswer6: 'O motorista aguarda até 60 minutos após o horário de aterragem previsto sem custos adicionais. Este tempo é suficiente para recolher bagagem e passar pela alfândega. Se precisar de mais tempo, contacte-nos com antecedência.',
  
  faqQuestion7: 'Como identifico o motorista?',
  faqAnswer7: 'O motorista estará com uma placa com o seu nome completo (conforme indicado na reserva) e uniforme da FARWAYS. Todos os nossos motoristas são profissionais licenciados e identificados. Em caso de dúvida, pode sempre ligar para o número de emergência fornecido no email de confirmação.',
  
  // FAQ Questions and Answers - Bagagem
  faqQuestion8: 'Qual o tamanho de uma mala média e de uma mala pequena?',
  faqAnswer8: 'Mala média: aproximadamente 65-70 cm (26-27 polegadas) - bagagem de porão padrão\nMala pequena: cerca de 35 cm (14 polegadas) - mochila ou mala de mão\n\nSe tiver bagagem grande, especial (tacos de golfe, bicicletas, etc.) ou em quantidade superior ao padrão, indique no campo "Observações" ao fazer a reserva para garantirmos o veículo adequado.',
  
  faqQuestion9: 'Vocês fornecem cadeirinhas para crianças?',
  faqAnswer9: 'Sim! Disponibilizamos cadeiras para crianças e bebés mediante solicitação:\n\n• 0-1 anos (Grupo 0+): €7\n• 1-3 anos (Grupo 1): €6\n• 5-12 anos (Grupo 2/3): €4\n\nPode solicitar na secção "Assentos para Crianças" durante a reserva. As cadeiras cumprem todas as normas de segurança europeias.',
  
  faqQuestion10: 'Posso levar bagagem extra?',
  faqAnswer10: 'Sim, mas é importante informar na reserva. Cada tipo de veículo tem capacidade específica de bagagem. Se tiver mais bagagem que o padrão, podemos sugerir um veículo maior ou organizar transporte adicional. Indique sempre no campo "Observações" itens especiais como equipamento desportivo, carrinhos de bebé, etc.',
  
  // FAQ Questions and Answers - Serviço
  faqQuestion11: 'Vou partilhar o veículo com outros passageiros?',
  faqAnswer11: 'Não! Todos os nossos serviços são transfers PRIVADOS. Você e o seu grupo serão os únicos ocupantes do veículo. Não fazemos transfers partilhados. O veículo é exclusivamente seu durante toda a viagem, garantindo conforto, privacidade e pontualidade.',
  
  faqQuestion12: 'O que está incluído no serviço de transfer?',
  faqAnswer12: 'O nosso serviço inclui:\n\n✅ Motorista profissional licenciado\n✅ Veículo limpo e confortável\n✅ Ar condicionado\n✅ Wi-Fi gratuito\n✅ Água gratuita\n✅ Monitorização de voos\n✅ Serviço meet & greet no aeroporto\n✅ Ajuda com bagagem\n✅ Sem custos de espera (até 60 min no aeroporto)\n✅ Todos os impostos incluídos',
  
  faqQuestion13: 'O serviço leva-me diretamente ao hotel?',
  faqAnswer13: 'Sim! O nosso serviço de transfer privado leva-o diretamente do aeroporto à porta do seu hotel, apartamento ou qualquer outro endereço no Algarve. Sem paragens intermédias, sem esperas. Serviço porta-a-porta com máximo conforto e rapidez.',
  
  // FAQ Questions and Answers - Pagamento
  faqQuestion14: 'Quais as formas de pagamento aceites?',
  faqAnswer14: 'Aceitamos:\n\n💳 Cartão de crédito/débito (Visa, Mastercard, American Express)\n💰 Dinheiro (Euros) diretamente ao motorista\n🌐 PayPal (pagamento online)\n💼 Transferência bancária (para reservas empresariais)\n\nO pagamento online é seguro e processado através de plataforma certificada.',
  
  faqQuestion15: 'Os preços incluem todas as taxas?',
  faqAnswer15: 'Sim! Os preços apresentados no nosso site são FINAIS e incluem:\n\n✅ IVA à taxa legal\n✅ Todas as taxas e impostos\n✅ Combustível\n✅ Portagens (se aplicável)\n✅ Seguro completo\n✅ Sem custos escondidos\n\nO preço que vê é o preço que paga. Garantido!',
  
  faqQuestion16: 'Há desconto para viagens de ida e volta?',
  faqAnswer16: 'Sim! Oferecemos 10% de desconto automático em todas as reservas de ida e volta. Além disso, temos uma promoção especial de inverno (Novembro a Março) com 30% de desconto + 10% adicional em viagens de ida e volta. Os descontos são aplicados automaticamente no momento da reserva.',
  
  // FAQ Questions and Answers - Segurança
  faqQuestion17: 'Os motoristas são licenciados?',
  faqAnswer17: 'Sim! Todos os nossos motoristas são:\n\n✅ Licenciados profissionalmente (TVDE/Transfer)\n✅ Com experiência mínima de 5 anos\n✅ Certificados pela autoridade de transportes\n✅ Com conhecimento profundo do Algarve\n✅ Fluentes em Português, Inglês e Espanhol\n✅ Formados em atendimento ao cliente\n✅ Com registo criminal limpo',
  
  faqQuestion18: 'Os veículos têm seguro?',
  faqAnswer18: 'Sim! Todos os nossos veículos têm:\n\n✅ Seguro contra todos os riscos\n✅ Seguro de passageiros\n✅ Inspeções técnicas em dia\n✅ Manutenção regular\n✅ Limpeza e desinfeção após cada serviço\n✅ Equipamento de segurança completo\n\nA sua segurança é a nossa prioridade máxima.',
  
  faqQuestion19: 'Como posso ter certeza que a reserva é legítima?',
  faqAnswer19: 'A FARWAYS é uma empresa registada e licenciada:\n\n📋 NIPC: 505413850\n📋 RNAVT: 8586 (Registo Nacional de Agentes de Viagens)\n📋 Licença de transporte válida\n📋 Mais de 15 anos de experiência\n📋 +5000 clientes satisfeitos\n📋 Avaliações verificadas\n\nReceberá email de confirmação imediato com todos os detalhes e número de reserva. Pode sempre verificar a legitimidade contactando-nos diretamente.',
  
  // FAQ Additional
  faqNoResults: 'Nenhuma pergunta encontrada nesta categoria',
  faqStillHaveQuestions: 'Ainda tem dúvidas?',
  faqContactText: 'A nossa equipa está disponível 24/7 para ajudar',
  faqContactButton: 'Contacte-nos',
};
